module.exports = __webpack_public_path__ + "static/media/Logo.fc10bb29.png";